const { camelize } = require('./utils/camelize')

const { isContainsHtmlTag } = require('./utils/isContainsHtmlTag')
const { getRandomLetters }  = require('./utils/getRandomLetters')
const { indentNormalize }   = require('./utils/indentNormalize')
const { formatCurrency }    = require('./utils/formatCurrency')
const { replaceAtEnd }      = require('./utils/replaceAtEnd')
const { formatNumber }      = require('./utils/formatNumber')
const { toPascalCase }      = require('./utils/toPascalCase')
const { toKebabCase }       = require('./utils/toKebabCase')
const { toSnakeCase }       = require('./utils/toSnakeCase')
const { truncate }          = require('./utils/truncate')
const { lcFirst }           = require('./utils/lcFirst')
const { slugify }           = require('./utils/slugify')
const { ucFirst }           = require('./utils/ucFirst')
const { ltrim }             = require('./utils/ltrim')
const { rtrim }             = require('./utils/rtrim')
const { trim }              = require('./utils/trim')
const { pad }               = require('./utils/pad')

const String = {
  getRandomLetters,
  camelize,
  truncate,
  indentNormalize,
  isContainsHtmlTag,
  formatCurrency,
  formatNumber,
  lcFirst,
  ltrim,
  replaceAtEnd,
  rtrim,
  slugify,
  toKebabCase,
  toPascalCase,
  toSnakeCase,
  trim,
  ucFirst,
  pad
}

module.exports.String = String
